import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import VueWow from 'vue-wow'

import VueCarousel from 'vue-carousel';
Vue.use(VueLodash, {  lodash: lodash })

Vue.config.productionTip = false

Vue.use(VueCarousel);
Vue.use(VueWow)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
